import React from 'react'
import './password-reset.css'
import Axios from 'axios'
import { baseUrl } from '../assets/Animations'

export function PasswordReset(props) {
    function closeResetModal(id) {
        if(id === 'reset-wrapper') {
            props.toggleReset()
        }
    }
    function closeModal() {
        props.toggleReset()
    }
    function submitPassReset() {
        let theEmail = document.getElementById('password-reset-input').value
        let randomPassword = Math.random().toString(16).slice(2)
        Axios.put(`${baseUrl}/fullpassreset`, {
            Email: theEmail,
            Password: randomPassword,
            School: props.schoolName
        })
        .then(response => {
            if(response.status === 200) {
                alert('Your password has been reset. Please check your email.')
            } else {
                alert('Sorry! There seems to be a problem. Please send us an email and we will reset your password.')
            }
        })
        .catch(e => {
            console.log('Oops ' + e)
            console.log(e)
        })
        closeModal()
    }

    if(props.resetOpen === true) {
        return(
            <div className="reset-wrapper" id="reset-wrapper" onClick={(e) => closeResetModal(e.target.id)}>
                <div className="reset-box">
                    <div className="close-reset-wrapper-x">
                        <div className="close-reset-x" onClick={() => closeModal()}>x</div>
                    </div>
                    <div className="reset-text-wrapper">
                        <div className="reset-desc">
                            Please enter your email address and you will be emailed a new password.<br></br>
                            When you first log in with your new password you will be able to reset it.<br></br>
                            <strong>(Enter the email you use to log in)</strong>
                        </div>
                        <input className="password-reset-input" id="password-reset-input" placeholder="Email" />
                    </div>
                    <div className="reset-submit-btn" onClick={() => submitPassReset()}>Reset</div>
                </div>
            </div>
        )
    } else {
        return null
    }
}